import { useContext, useState, useEffect } from "react";
import { CurrentUserContext } from "../security/SecurityContext";
import { useOktaAuth } from "@okta/okta-react";
import { SecurityContext } from "../security/WrappedSecurity";
import { UserContext } from "../context/UserContext";
import _ from "lodash";
import UserUtils from "../utils/UserUtils";

const useSecurity = () => {
  const [userInfo] = useContext(CurrentUserContext);
  const [isSecurityLoaded, userScopes] = useContext(SecurityContext);
  const { authState, oktaAuth } = useOktaAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { lists } = useContext(UserContext);
  const [user, setUser] = useState();

  // update "isAuthenticated" when everything is done
  useEffect(() => {
    setIsAuthenticated((authState?authState.isAuthenticated:false) && isSecurityLoaded);
  }, [isSecurityLoaded, authState]);

  useEffect(() => {
    if (!_.isEmpty(lists) && !_.isEmpty(userInfo)) {
      setUser(UserUtils.getUser(userInfo, lists));
    }
  }, [lists, userInfo]);

  return {
    userInfo: _.isEmpty(user) ? userInfo : user,
    authService: oktaAuth,
    isAuthenticated,
    userScopes,
    isPending: authState?.isPending,
    // code needs to "refetch" token because it might have changed in authState
    getAccessToken: oktaAuth.getAccessToken(),
    idToken: authState?.idToken,
  };
};

export default useSecurity;
